export const InvoicesKey = 'invoices';
